// @flow
import React, { Component } from 'react'
import { translateFunc, translations } from '../../shared/localize'
import _ from 'lodash'
import styled from 'styled-components'
import { HeaderCell, HeaderRow } from '../MainTable'

const CampaignName = styled(HeaderCell)`
  text-align: left;
`
const CampaignStatus = styled(HeaderCell)`
  width: 80px;
  text-align: left;
`
const Advertisements = styled(HeaderCell)`
  width: 100px;
  text-align: left;
`
const CenterHeader = styled(HeaderCell)`
  text-align: center;
`
const StyledIcon = styled.i`
  cursor: pointer;
`

type Props = {|
  headers: Array<string>,
  onCogClick: Function,
  onRefreshClick: Function
|}

const t = translateFunc(translations.table_headers)

export default class Thead extends Component<Props> {
  render() {
    const { headers } = this.props
    return (
      <thead>
        <HeaderRow>
          {_.map(headers, (header: string) => {
            switch (header) {
              case 'status_checkbox':
                return <HeaderCell key={header} />
              case 'campaign':
                return <CampaignName key={header}>{t(header)}</CampaignName>
              case 'status':
                return <CampaignStatus key={header}>{t(header)}</CampaignStatus>
              case 'advertisements':
                return <Advertisements key={header}>{t(header)}</Advertisements>
              case 'users':
                return (
                  <CenterHeader key={header}>
                    {t(header)}{' '}
                    <StyledIcon
                      className="glyphicon glyphicon-refresh t-RefreshEstimates"
                      onClick={() => this.props.onRefreshClick()}
                    />
                  </CenterHeader>
                )
              case 'modal_cog':
                return (
                  <CenterHeader key={header}>
                    <i
                      className="glyphicon glyphicon-cog t-TableHeaders"
                      onClick={() => this.props.onCogClick()}
                    />
                  </CenterHeader>
                )
              default:
                return <HeaderCell key={header}>{t(header)}</HeaderCell>
            }
          })}
        </HeaderRow>
      </thead>
    )
  }
}
